export default __webpack_public_path__ + "static/media/mp_checkbox_checked.a817dc79.svg";